export default "__VITE_ASSET__2uuywG$Y__"